/**
 * Created by zzy on 2019/8/1.
 */
import Camera from './Camera.vue'
export default Camera



// WEBPACK FOOTER //
// ./src/views/assets/camera/index.js